<template>
  <div id="DmhLocation">
    <i class="fas fa-map-marker-alt brand-primary"></i>
    <div v-if="gettingLocation">
      <h3 class="title">In order to protect your safety while you use our services, please enable your location services</h3>
      <div class="location-text">
        <p class="location-paragraph">Learn how to change your browser's location services <button @click="goToLocationArticle" class="brand-primary location-link">here</button>.</p>
      </div>
    </div>
    <div
      v-else
      class="mt-4"
    >
      <h3 class="title">{{ titleText }}</h3>
      <div class="location-text">
        <p class="location-paragraph">In order to protect your safety while you use our services, we recommend you continue to use your location services.</p>
        <p class="location-paragraph">Learn how to change your browser's location services <button @click="goToLocationArticle" class="brand-primary location-link">here</button>.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Location",
  props: ["question", "setAnswer", "apiQuestionnaire"],
  data() {
    return {
      gettingLocation: true,
      address: null,
      longitude: null,
      latitude: null,
      checker: null,
      iOSLink: "https://support.apple.com/en-us/HT203033",
      macLink:
        "https://support.apple.com/en-gb/guide/mac-help/mh35873/15.0/mac/15.0",
      chromeLink: "https://support.google.com/chrome/answer/142065",
      firefoxLink:
        "https://support.mozilla.org/en-US/kb/does-firefox-share-my-location-websites"
    };
  },
  mounted() {
    this.setAnswer({
      lat: null,
      lng: null,
      address: null
    });
    this.getLocation();
  },
  beforeDestroy() {
    if (this.checker !== null) clearInterval(this.checker);
  },
  methods: {
    updateCoordinates(newLatLng) {
      this.updateLocation({
        coords: {
          latitude: newLatLng.lat,
          longitude: newLatLng.lng
        }
      });
    },
    async getAddress() {
      this.address = null;
      try {
        const res = await this.apiQuestionnaire.getAddressFromCoordinates({
          lat: this.latitude,
          lng: this.longitude
        });
        if (res.data?.success) {
          this.address = res.data.display_name;
        }
      } catch (err) {
        console.error(err);
      }
    },
    async updateLocation(position) {
      if (this.checker !== null) clearInterval(this.checker);
      this.latitude = position.coords.latitude;
      this.longitude = position.coords.longitude;
      await this.getAddress();
      this.gettingLocation = false;
      this.setAnswer({
        lat: this.latitude,
        lng: this.longitude,
        address: this.address
      });
    },
    goToLocationArticle() {
      if (this.locationServiceHelpLink) {
        window.open(this.locationServiceHelpLink, "_blank");
      }
    },
    onError() {
      if (this.checker === null) {
        this.checker = setInterval(this.getLocation, 1000);
      }
      this.gettingLocation = false;
    },
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          this.updateLocation,
          this.onError,
          {
            enableHighAccuracy: true,
            maximumAge: 0
          }
        );
      } else {
        console.error("Geolocation is not supported by your browser.");
      }
    }
  },
  computed: {
    locationServiceHelpLink() {
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.includes("safari") && !userAgent.includes("chrome")) {
        if (
          userAgent.includes("iphone") ||
          userAgent.includes("ipad") ||
          userAgent.includes("ipod")
        ) {
          return this.iOSLink;
        } else if (
          userAgent.includes("macintosh") ||
          userAgent.includes("mac os")
        ) {
          return this.macLink;
        }
      } else if (userAgent.includes("chrome")) {
        return this.chromeLink;
      } else if (userAgent.includes("firefox")) {
        return this.firefoxLink;
      }
      return null;
    },
    titleText() {
      return this.longitude ? "Location services are enabled" : "Location services are disabled";
    }
  }
};
</script>

<style lang="less">
#DmhLocation {
  width: 600px;
  max-width: 100%;
  margin: 0 auto;
  text-align: center;
  color: #1e1e22;
  .fa-map-marker-alt {
    font-size: 10rem;
  }
  h3,
  h5 {
    font-family: var(--font-bold, "DMSans Bold");
    font-size: 2.2rem;
    text-align: center;
    letter-spacing: unset;
    color: #1e1e22;
  }
  h5 {
    font-size: 1.6rem;
  }
  .title {
    text-align: center;
    max-width: 372px;
    margin: 0 auto;
    font-size: 2.2rem;
    font-family: var(--font-bold, "DMSans Bold");
    padding: 38px 0;
  }
  .location-text {
    font-family: var(--font-regular, "DMSans");
    font-size: 1.6rem;
  }
  .location-paragraph {
    color: #1E1E22;
  }
  .location-link {
    border: 0;
    background-color: transparent;
    font-family: var(--font-bold, "DMSans Bold");
    font-size: 1.6rem;
    text-decoration: underline;
    cursor: pointer;
    padding: 0;
  }
}
</style>
